import request from '@core/services/request';

export const reportsAPI = {
	getProductsReport: (reportRequest: any) => request.post(`/Reports/GetProductsReport`, reportRequest),
	getCbcCreditPullsReport: (reportRequest: any) => request.post(`/Reports/GetCbcCreditPullsReport`, reportRequest),
	getDealsReport: (reportRequest: any) => request.post(`/Reports/getDealsReport`, reportRequest),
	getTradesAccidentsReport: (reportRequest: any) => request.post(`/Reports/GetTradesAccidentsReport`, reportRequest),
};
